/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useEffect } from "react";
import styles from "./styles.css";
// import MakeFilter from "../make-filter";
import PropTypes from "prop-types";
import NudgeCard from "../nudge-cards";
import TrackImpression from "../../shared/track-impression";
import BookedTasks from "../booked-tasks";
import LandingBannerSellRevamp from "../landing-banner-sell-revamp/component";
import { ORDER_STATUS } from "../../../constants/checkout-constants";
import { appUrl } from "../../../constants/url-constants";
import { API_VERSION_V2 } from "../../../service/api-version";
import FestivalBanner from "../festival-banner/component";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
const HomeBanner = ({
    fetchConfigConnect,
    saleConfig,
    isLoggedIn,
    bookedTasks,
    secureToken,
    fetchBookedTasksListConnect,
    fetchFiltersConnect,
    bookings,
    getPreApprovalLoanDetailsConnect,
    eventBanners
    // setCurrentScreenConnect
}) => {
    const { cars: myBookingsOrder } = bookings || {};
    const myBookingsLastOrder = Array.isArray(myBookingsOrder) && myBookingsOrder[0];
    const {
        booked,
        reserved,
        zeroDp,
        bookingState
    } = myBookingsLastOrder || {};
    const carAvailable = !booked && !reserved && zeroDp && bookingState === ORDER_STATUS.CANCELED;
    const sellCarURL = `${appUrl()}/sell-your-car?utm_source=home-banner&utm_medium=Msite&utm_campaign=Homepage-banner-redirection&utm_id=Main-CTA-Redirect`;
    const showFestiveBannerVariant = getAbExpirementVariant(eventBanners, EXPERIMENT_TYPE.VARIANT_B);
    /**
     * showHomepageRevamp will be true if the user is in the variant B of the experiment
     */

    const { saleLive } = saleConfig?.data || saleConfig || {};

    useEffect(() => {
        if (saleConfig && !saleConfig.isSSR) {
            fetchConfigConnect();
        }
        fetchFiltersConnect(API_VERSION_V2);        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (secureToken) {
            fetchBookedTasksListConnect(secureToken);
            getPreApprovalLoanDetailsConnect({fetchListingDetails: true});

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secureToken]);

    const isTaskAvailable = (bookedTasks || []).length > 0;

    const festivalComponent = showFestiveBannerVariant && FestivalBanner;
    const Component = festivalComponent || LandingBannerSellRevamp;

    return (
        <TrackImpression event={{ name: "landingBannerViewd" }}>
            <div styleName={(saleLive && isLoggedIn && isTaskAvailable) ? "styles.bottomMargin" : ""}>
                <div>
                    {secureToken &&
                        <div styleName={"styles.nudgeCardContainer styles.nudgeCardContainerNew"}>
                            <NudgeCard />
                        </div>
                    }
                    <Component
                        isLoggedIn={isLoggedIn}
                        bookedTasks={isLoggedIn ? bookedTasks : []}
                        carAvailable={carAvailable}
                        sellCarURL={sellCarURL}
                        saleLive={saleLive}
                    />
                </div>
                {!!isLoggedIn && isTaskAvailable &&
                <div styleName={saleLive ? "styles.marginTop" : ""}>
                    <BookedTasks saleLive={saleLive} showFestiveBannerVariant={showFestiveBannerVariant}/>
                </div>
                }

            </div>
        </TrackImpression>
    );
};

HomeBanner.propTypes = {
    setShowAllowTrackingConnect: PropTypes.func,
    showAllowTracking: PropTypes.bool,
    isUserZeroDpVariant: PropTypes.bool,
    secureToken: PropTypes.string,
    fetchConfigConnect: PropTypes.func,
    saleConfig: PropTypes.object,
    sendAppLinkConnect: PropTypes.func,
    updateFilterOptionDataConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    allFilters: PropTypes.object,
    selectedCity: PropTypes.string,
    setCurrentScreenConnect: PropTypes.func,
    bookings: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    bookedTasks: PropTypes.array,
    fetchBookedTasksListConnect: PropTypes.func,
    fetchFiltersConnect: PropTypes.func,
    getPreApprovalLoanDetailsConnect: PropTypes.func,
    eventBanners: PropTypes.object
};
export default HomeBanner;

